<template>
  <el-form label-width="130px">
    <el-row>
      <el-col :span="8">
        <el-form-item label="注册时间">
          <el-input v-model="detailsData.registrationDate" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="最近登陆时间">
          <el-input v-model="detailsData.loginDate" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="是否关注公众号">
          <el-input v-model="detailsData.followTheOfficialAccount" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="是否查看公司信息">
          <el-input v-model="detailsData.viewCompanyInformation" readonly></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="form-title">签到时间</div>
        <vxe-table :data="list">
          <vxe-table-column field="signTime" title="签到时间"></vxe-table-column>
          <vxe-table-column field="signStats" title="是否签到">
            <template #default="{ row }">
              <div>{{ row.signStats === '1' ? '是' : '否' }}</div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import request from '@/found/utils/request';

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
        };
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          const row = JSON.parse(JSON.stringify(val));
          row.followTheOfficialAccount = row.followTheOfficialAccount === '1' ? '是' : '否';
          row.viewCompanyInformation = row.viewCompanyInformation === '1' ? '是' : '否';
          this.detailsData = row;
          console.log(val, '---');
          this.getPagelist();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      detailsData: {},
      list: [],
    };
  },
  methods: {
    // 获取详情
    getPagelist() {
      console.log(this.detailsData);
      if (this.detailsData.consumerPhone) {
        const params = {
          consumerPhone: this.detailsData.consumerPhone,
          pageSize: 1000,
        };
        const url = '/cps/v1/memberSignRecord/memberSignRecord/findByConditions';
        request.post(url, params).then((res) => {
          if (res.success) {
            this.list = res.result.data || [];
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.form-title {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
</style>
